import { destroyCookie } from 'nookies'
import { AsyncAction, createFingerprint, createProfilingId, authLogout, resetAuthData, resetConsumerData } from './index'
import { COOKIE_SHOW_NEW_PORTAL, COOKIE_SHOW_OLD_PORTAL } from '../utils/redirects'
import { clearUserFromStorage } from '../utils/userStorage'

export const initialise = (): AsyncAction<void> => async (dispatch) => {
  await dispatch(createProfilingId())
  await dispatch(createFingerprint())
}

export const clearCookie = (): void => {
  destroyCookie(null, COOKIE_SHOW_NEW_PORTAL)
  destroyCookie(null, COOKIE_SHOW_OLD_PORTAL)
}

export const clearState =
  (backToShop = true): AsyncAction<void> =>
  async (dispatch) => {
    backToShop && clearCookie()
    clearUserFromStorage()
    await dispatch(resetAuthData())
    await dispatch(resetConsumerData())
    await dispatch(authLogout({ backToShop }))
  }
